import { request } from './client';
import type { QueryParams } from './client';

export function fetchFacebookNetworks(params: QueryParams = {}): Promise<{ data: any }> {
  return request('GET', '/v1/account/facebook/accounts', params);
}
export function deleteFacebookNetwork(networkId: number, params: QueryParams = {}): Promise<{ data: any }> {
  return request('DELETE', `/v1/account/facebook/accounts/${networkId}`, params);
}
export function fetchFacebookRedirectionURI(): Promise<{ redirect_url: string }> {
  return request('GET', '/v1/account/facebook/link_pages', { mode: 'copy' });
}
export function authorizeFacebookPageWithCode(params: QueryParams = {}): Promise<{ data: any }> {
  return request('GET', '/v1/account/facebook/accounts/callback', params);
}
